import { Component, OnInit, Input } from '@angular/core';
import { SharedRankingHistoryService } from './shared-ranking-history.service';

@Component({
    selector: 'app-shared-ranking-history',
    templateUrl: './shared-ranking-history.component.html',
    styleUrls: ['./shared-ranking-history.component.scss'],
})
export class SharedRankingHistoryComponent implements OnInit {
    /**
     * departmentType
     * Tipo de departamento do ranking selecionado
     */
    @Input() departmentType: any;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    filter: any;
    filterPost: any;
    classif: any;
    columns = [];

    constructor(private rankingService: SharedRankingHistoryService) {}

    ngOnInit(): void {
        //console.log('Entrei=' + this.departmentType);
        this.rankingList();
    }

    /**
     * onFilterChange(): Ao mudar parãmetro de filtro
     * @param event Objeto com parâmetros selecionados/alterado através do filtro
     */
    onFilterChange(event) {
        this.rankingList(event);
    }

    /**
     * rankingList() - Buscar classificação do filtro de ranking
     */
    rankingList(event: object = null) {
        this.rankingService.getRanking(this.departmentType, event).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.filter = response.registers.filters;
        this.columns = response.registers.list.header;
        this.classif = response.registers.list.rows;
        //console.log('columns ');
        //console.log(this.registers);
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
        this.filter = null;
        this.columns = null;
        this.classif = null;
    }
}
